import ComponentsFactory from 'foundation/components-factory';
import BasketCleanerComponent from './js/basket-cleaner.component';

ComponentsFactory.getInstance().define('basket-cleaner', BasketCleanerComponent);
